import { InjectApp, startApp, Vue } from '@acgn/herm';
import '@/assets/style/common.scss';
import store from './store';
import { customRoutes } from './router';
import plugins from './plugins';

Vue.use(plugins);


const injectDesk = new InjectApp('desk', {
  path: '/desk',
  text: 'OA管理中心'
});

injectDesk.store(store);
injectDesk.router(customRoutes);

startApp();
